module.exports = __webpack_public_path__ + "img/mk.f26a7830.svg";